import AbstractEntity from '../../../../vendors/@types/AbstractEntity';
import {useState} from 'react';

export default class ContribuinteModel extends AbstractEntity {

    public tpInscricao: any;
    public setTpInscricao: any;
    public nuInscricao: any;
    public setNuInscricao: any;
    public stNotificarNovaAudiencia: any;
    public setStNotificarNovaAudiencia: any;
    public noRazaoSocial: any;
    public setNoRazaoSocial: any;
    public tpContribuinte: any;
    public setTpContribuinte: any;
    public stAtivo: any;
    public setStAtivo: any;
    public dsEmail: any;
    public setDsEmail: any;
    public cdTipoInteressado: any;
    public setCdTipoInteressado: any;
    public cdUf: any;
    public setCdUf: any;
    public cdMunicipio: any;
    public setCdMunicipio: any;
    public tipoInteressadoOutros: any;
    public setTipoInteressadoOutros: any;
    public rlContribuinteAreaInteresse: any;
    public setRlContribuinteAreaInteresse: any;
    public codContribuinte: any;
    public setCodContribuinte: any;

    public ufValid: any;
    public setUfValid: any;
    public municipioValid: any;
    public setMunicipioValid: any;
    public tipoInteressadoValid: any;
    public setTipoInteressadoValid: any;
    public areaInteresseValid: any;
    public setAreaInteresseValid: any;

    public constructor() {
        super();
        [this.tpInscricao, this.setTpInscricao] = useState('');
        [this.nuInscricao, this.setNuInscricao] = useState('');
        [this.stNotificarNovaAudiencia, this.setStNotificarNovaAudiencia] = useState(false);
        [this.noRazaoSocial, this.setNoRazaoSocial] = useState('');
        [this.tpContribuinte, this.setTpContribuinte] = useState('');
        [this.stAtivo, this.setStAtivo] = useState('');
        [this.dsEmail, this.setDsEmail] = useState('');
        [this.cdTipoInteressado, this.setCdTipoInteressado] = useState('');
        [this.cdUf, this.setCdUf] = useState('');
        [this.cdMunicipio, this.setCdMunicipio] = useState('');
        [this.tipoInteressadoOutros, this.setTipoInteressadoOutros] = useState('');
        [this.rlContribuinteAreaInteresse, this.setRlContribuinteAreaInteresse] = useState([]);
        [this.codContribuinte, this.setCodContribuinte] = useState(null);

        [this.ufValid, this.setUfValid] = useState(true);
        [this.municipioValid, this.setMunicipioValid] = useState(true);
        [this.tipoInteressadoValid, this.setTipoInteressadoValid] = useState(true);
        [this.areaInteresseValid, this.setAreaInteresseValid] = useState(true);

    }

}
